module.exports = __webpack_public_path__ + "fa-regular-400.7124eb50fc8227c78269.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-regular-400.woff
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.woff
// module chunks = styles